<template>
    <strong class="mead-status-indicator">!</strong>
</template>
<script>
export default {
    name: 'mead-status-indicator',
}
</script>
<style lang="scss">
@import '../../../../sass/_variables.scss';
.mead-status-indicator {
    width: $fs-xl;
    height: $fs-xl;
    min-width: $fs-xl;
    min-height: $fs-xl;
    line-height: $fs-xl;
    border-radius: $br-m;
    font-weight: bold;
    padding: 0;
    display: inline-block;
    text-align: center;
    color: var(--c-brand-warning-fg);
    background-color: var(--c-brand-warning-bg);
}
</style>